import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Mail, School, Award, BookOpen, Clock, Edit, Save, X, Target, TrendingUp, Star, Bell, LogOut, ChevronRight, Phone, MapPin, Baby, Key, CreditCard, Eye, EyeOff, CheckCircle } from 'lucide-react';
export function VeliProfil() {
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  // State'ler
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  // Password modal states
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordError, setPasswordError] = useState<string | null>(null);
  // Email modal states
  const [newEmail, setNewEmail] = useState('');
  const [emailPassword, setEmailPassword] = useState('');
  const [showEmailPassword, setShowEmailPassword] = useState(false);
  const [emailError, setEmailError] = useState<string | null>(null);
  const [emailVerificationSent, setEmailVerificationSent] = useState(false);
  // Veli profil verisi
  const [profileData, setProfileData] = useState({
    name: 'Mehmet Demir',
    email: 'mehmet.demir@email.com',
    phone: '+90 532 123 45 67',
    address: 'İstanbul / Kadıköy',
    membershipType: 'Premium',
    membershipStart: '2023-09-01',
    membershipEnd: '2024-09-01'
  });
  // Çocuk bilgileri
  const childData = {
    name: 'Elif Demir',
    school: 'Atatürk Ortaokulu',
    grade: '8. Sınıf',
    targetExam: 'LGS 2025'
  };
  // Çocuğun performans istatistikleri
  const stats = [{
    title: 'Çözülen Soru',
    value: '1,458',
    icon: BookOpen,
    description: 'Toplam çözülen soru sayısı',
    gradientFrom: 'from-blue-500',
    gradientTo: 'to-blue-700'
  }, {
    title: 'En Yüksek Net',
    value: '82.5',
    icon: TrendingUp,
    description: 'Tüm denemelerdeki en yüksek net',
    gradientFrom: 'from-green-500',
    gradientTo: 'to-green-700'
  }, {
    title: 'En Başarılı Ders',
    value: 'Matematik',
    icon: Star,
    description: 'En yüksek başarı oranına sahip ders',
    gradientFrom: 'from-yellow-500',
    gradientTo: 'to-yellow-700'
  }, {
    title: 'Toplam Çalışma',
    value: '256 saat',
    icon: Clock,
    description: 'Platformda geçirilen toplam süre',
    gradientFrom: 'from-blue-600',
    gradientTo: 'to-blue-800'
  }];
  const handleLogout = () => {
    navigate('/');
  };
  const handlePasswordSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setPasswordError(null);
    if (newPassword.length < 8) {
      setPasswordError('Şifre en az 8 karakter uzunluğunda olmalıdır.');
      return;
    }
    if (!/[A-Z]/.test(newPassword)) {
      setPasswordError('Şifre en az bir büyük harf içermelidir.');
      return;
    }
    if (!/\d/.test(newPassword)) {
      setPasswordError('Şifre en az bir rakam içermelidir.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setPasswordError('Girdiğiniz yeni şifreler eşleşmiyor.');
      return;
    }
    // API call simulation
    setTimeout(() => {
      setShowPasswordModal(false);
      // Show success message
    }, 1000);
  };
  const handleEmailSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setEmailError(null);
    if (!/\S+@\S+\.\S+/.test(newEmail)) {
      setEmailError('Geçerli bir e-posta adresi giriniz.');
      return;
    }
    if (newEmail === profileData.email) {
      setEmailError('Yeni e-posta adresi mevcut adresinizle aynı olamaz.');
      return;
    }
    setEmailVerificationSent(true);
    // API call simulation
    setTimeout(() => {
      setProfileData({
        ...profileData,
        email: newEmail
      });
      setShowEmailModal(false);
      setEmailVerificationSent(false);
    }, 5000);
  };
  return <div className="space-y-8" data-id="element-966">
      <h1 className="text-2xl font-bold" data-id="element-967">Profil</h1>
      {/* VELİ PROFIL HEADER */}
      <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-968">
        <div className="relative p-6 bg-black/90 rounded-lg" data-id="element-969">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6" data-id="element-970">
            <div className="relative" data-id="element-971">
              <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=160&h=160&fit=crop&crop=faces" alt="Profile" className="w-24 h-24 rounded-full" data-id="element-972" />
              <button className="absolute -bottom-1 -right-1 p-1.5 rounded-full bg-blue-600 text-white hover:bg-blue-700 transition-colors" data-id="element-973">
                <Edit className="w-4 h-4" data-id="element-974" />
              </button>
            </div>
            <div className="flex-1 min-w-0" data-id="element-975">
              {isEditing ? <div className="space-y-4" data-id="element-976">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-977">
                    <div className="space-y-2" data-id="element-978">
                      <label className="text-sm text-gray-400" data-id="element-979">Ad Soyad</label>
                      <input type="text" value={profileData.name} onChange={e => setProfileData({
                    ...profileData,
                    name: e.target.value
                  })} className="w-full bg-white/5 text-white rounded-lg px-4 py-2" data-id="element-980" />
                    </div>
                    <div className="space-y-2" data-id="element-981">
                      <label className="text-sm text-gray-400" data-id="element-982">E-posta</label>
                      <input type="email" value={profileData.email} onChange={e => setProfileData({
                    ...profileData,
                    email: e.target.value
                  })} className="w-full bg-white/5 text-white rounded-lg px-4 py-2" data-id="element-983" />
                    </div>
                    <div className="space-y-2" data-id="element-984">
                      <label className="text-sm text-gray-400" data-id="element-985">Telefon</label>
                      <input type="tel" value={profileData.phone} onChange={e => setProfileData({
                    ...profileData,
                    phone: e.target.value
                  })} className="w-full bg-white/5 text-white rounded-lg px-4 py-2" data-id="element-986" />
                    </div>
                    <div className="space-y-2" data-id="element-987">
                      <label className="text-sm text-gray-400" data-id="element-988">Adres</label>
                      <input type="text" value={profileData.address} onChange={e => setProfileData({
                    ...profileData,
                    address: e.target.value
                  })} className="w-full bg-white/5 text-white rounded-lg px-4 py-2" data-id="element-989" />
                    </div>
                  </div>
                  <div className="flex justify-end gap-3" data-id="element-990">
                    <button onClick={() => setIsEditing(false)} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/5 hover:bg-white/10 transition-colors" data-id="element-991">
                      <X className="w-4 h-4" data-id="element-992" />
                      İptal
                    </button>
                    <button onClick={() => setIsEditing(false)} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900 transition-colors" data-id="element-993">
                      <Save className="w-4 h-4" data-id="element-994" />
                      Kaydet
                    </button>
                  </div>
                </div> : <div className="space-y-4" data-id="element-995">
                  <div className="flex items-center justify-between" data-id="element-996">
                    <h2 className="text-2xl font-bold" data-id="element-997">{profileData.name}</h2>
                    <button onClick={() => setIsEditing(true)} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/5 hover:bg-white/10 transition-colors" data-id="element-998">
                      <Edit className="w-4 h-4" data-id="element-999" />
                      Düzenle
                    </button>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2" data-id="element-1000">
                    <div className="flex items-center gap-2 text-gray-400" data-id="element-1001">
                      <Mail className="w-4 h-4" data-id="element-1002" />
                      <span data-id="element-1003">{profileData.email}</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-400" data-id="element-1004">
                      <Phone className="w-4 h-4" data-id="element-1005" />
                      <span data-id="element-1006">{profileData.phone}</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-400" data-id="element-1007">
                      <MapPin className="w-4 h-4" data-id="element-1008" />
                      <span data-id="element-1009">{profileData.address}</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-400" data-id="element-1010">
                      <Award className="w-4 h-4" data-id="element-1011" />
                      <span data-id="element-1012">{profileData.membershipType} Üyelik</span>
                    </div>
                  </div>
                </div>}
            </div>
          </div>
        </div>
      </div>
      {/* ÇOCUK BİLGİLERİ - YENİ TASARIM */}
      <div data-id="element-1013">
        <h2 className="text-xl font-bold mb-4" data-id="element-1014">Çocuk Bilgileri</h2>
        <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-1015">
          <div className="relative p-6 bg-black/90 rounded-lg" data-id="element-1016">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1017">
              <div className="space-y-4" data-id="element-1018">
                <div className="flex items-center gap-3 p-3 bg-white/5 rounded-lg" data-id="element-1019">
                  <Baby className="w-5 h-5 text-blue-400" data-id="element-1020" />
                  <div data-id="element-1021">
                    <p className="text-sm text-gray-400" data-id="element-1022">Öğrenci Adı</p>
                    <p className="font-medium" data-id="element-1023">{childData.name}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 p-3 bg-white/5 rounded-lg" data-id="element-1024">
                  <User className="w-5 h-5 text-blue-400" data-id="element-1025" />
                  <div data-id="element-1026">
                    <p className="text-sm text-gray-400" data-id="element-1027">Sınıf</p>
                    <p className="font-medium" data-id="element-1028">{childData.grade}</p>
                  </div>
                </div>
              </div>
              <div className="space-y-4" data-id="element-1029">
                <div className="flex items-center gap-3 p-3 bg-white/5 rounded-lg" data-id="element-1030">
                  <School className="w-5 h-5 text-blue-400" data-id="element-1031" />
                  <div data-id="element-1032">
                    <p className="text-sm text-gray-400" data-id="element-1033">Okul</p>
                    <p className="font-medium" data-id="element-1034">{childData.school}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 p-3 bg-white/5 rounded-lg" data-id="element-1035">
                  <Target className="w-5 h-5 text-blue-400" data-id="element-1036" />
                  <div data-id="element-1037">
                    <p className="text-sm text-gray-400" data-id="element-1038">Hedef Sınav</p>
                    <p className="font-medium" data-id="element-1039">{childData.targetExam}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ÇOCUĞUN PERFORMANS ÖZETİ */}
      <div data-id="element-1040">
        <h2 className="text-xl font-bold mb-4" data-id="element-1041">Çocuğun Performans Özeti</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1042">
          {stats.map(stat => <div key={stat.title} className={`relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r ${stat.gradientFrom} ${stat.gradientTo}`} data-id="element-1043">
              <div className="relative p-5 bg-black/90 rounded-lg h-full" data-id="element-1044">
                <div className="flex flex-col h-full" data-id="element-1045">
                  <div className="flex items-center justify-between mb-2" data-id="element-1046">
                    <h3 className="text-sm font-medium text-gray-400" data-id="element-1047">
                      {stat.title}
                    </h3>
                    <stat.icon className="w-5 h-5 text-gray-400" data-id="element-1048" />
                  </div>
                  <p className="text-2xl font-bold mb-1" data-id="element-1049">{stat.value}</p>
                  <p className="text-xs text-gray-500 mt-auto" data-id="element-1050">
                    {stat.description}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
      {/* HESAP AYARLARI - YENİ 3 BUTONLU DÜZEN */}
      <div data-id="element-1051">
        <h2 className="text-xl font-bold mb-4" data-id="element-1052">Hesap Ayarları</h2>
        <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-1053">
          <div className="relative p-6 bg-black/90 rounded-lg" data-id="element-1054">
            {/* 3 BUTON DİKEY DİZİLİM */}
            <div className="space-y-4" data-id="element-1055">
              {/* 1. ŞİFRE DEĞİŞTİR */}
              <button onClick={() => setShowPasswordModal(true)} className="w-full flex items-center justify-between p-4 bg-white/5 hover:bg-white/10 rounded-lg transition-colors border border-gray-700/50 hover:border-blue-500/30" data-id="element-1056">
                <div className="flex items-center gap-4" data-id="element-1057">
                  <div className="w-10 h-10 rounded-full bg-blue-500/20 flex items-center justify-center" data-id="element-1058">
                    <Key className="w-5 h-5 text-blue-400" data-id="element-1059" />
                  </div>
                  <div className="text-left" data-id="element-1060">
                    <span className="font-medium" data-id="element-1061">Şifre Değiştir</span>
                    <p className="text-sm text-gray-400 mt-0.5" data-id="element-1062">
                      Hesabınızın güvenliği için şifrenizi güncelleyin
                    </p>
                  </div>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-500" data-id="element-1063" />
              </button>
              {/* 2. E-POSTA GÜNCELLE */}
              <button onClick={() => setShowEmailModal(true)} className="w-full flex items-center justify-between p-4 bg-white/5 hover:bg-white/10 rounded-lg transition-colors border border-gray-700/50 hover:border-blue-500/30" data-id="element-1064">
                <div className="flex items-center gap-4" data-id="element-1065">
                  <div className="w-10 h-10 rounded-full bg-blue-500/20 flex items-center justify-center" data-id="element-1066">
                    <Mail className="w-5 h-5 text-blue-400" data-id="element-1067" />
                  </div>
                  <div className="text-left" data-id="element-1068">
                    <span className="font-medium" data-id="element-1069">E-posta Güncelle</span>
                    <p className="text-sm text-gray-400 mt-0.5" data-id="element-1070">
                      İletişim e-posta adresinizi değiştirin
                    </p>
                  </div>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-500" data-id="element-1071" />
              </button>
              {/* 3. ABONELİK BİLGİLERİ */}
              <button onClick={() => navigate('/abonelik-bilgileri')} className="w-full flex items-center justify-between p-4 bg-white/5 hover:bg-white/10 rounded-lg transition-colors border border-gray-700/50 hover:border-blue-500/30" data-id="element-1072">
                <div className="flex items-center gap-4" data-id="element-1073">
                  <div className="w-10 h-10 rounded-full bg-blue-500/20 flex items-center justify-center" data-id="element-1074">
                    <CreditCard className="w-5 h-5 text-blue-400" data-id="element-1075" />
                  </div>
                  <div className="text-left" data-id="element-1076">
                    <span className="font-medium" data-id="element-1077">Abonelik Bilgileri</span>
                    <p className="text-sm text-gray-400 mt-0.5" data-id="element-1078">
                      Paket bilgilerinizi ve fatura geçmişinizi görün
                    </p>
                  </div>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-500" data-id="element-1079" />
              </button>
            </div>
            {/* ÇIKIŞ YAP - AYRI BÖLÜM */}
            <div className="mt-8 pt-6 border-t border-gray-800" data-id="element-1080">
              <button onClick={() => setShowLogoutModal(true)} className="flex items-center gap-3 px-4 py-3 rounded-lg bg-white/5 hover:bg-red-500/10 transition-colors text-red-400 hover:text-red-300 border border-red-500/20 hover:border-red-500/40" data-id="element-1081">
                <LogOut className="w-5 h-5" data-id="element-1082" />
                <span className="font-medium" data-id="element-1083">Çıkış Yap</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* PASSWORD CHANGE MODAL - LAÇİVERT TEMA */}
      {showPasswordModal && <div className="fixed inset-0 bg-black/75 flex items-center justify-center p-4 z-50" data-id="element-1084">
          <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800 w-full max-w-md" data-id="element-1085">
            <div className="relative bg-black/90 rounded-xl p-6" data-id="element-1086">
              <div className="flex justify-between items-center mb-6" data-id="element-1087">
                <h2 className="text-xl font-bold" data-id="element-1088">Şifre Değiştir</h2>
                <button onClick={() => setShowPasswordModal(false)} className="text-gray-400 hover:text-white" data-id="element-1089">
                  <X className="w-6 h-6" data-id="element-1090" />
                </button>
              </div>
              <form onSubmit={handlePasswordSubmit} className="space-y-4" data-id="element-1091">
                <div className="space-y-2" data-id="element-1092">
                  <label className="block text-sm font-medium" data-id="element-1093">
                    Mevcut Şifre
                  </label>
                  <div className="relative" data-id="element-1094">
                    <input type={showCurrentPassword ? 'text' : 'password'} value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-2.5 pr-10 focus:ring-2 ring-blue-500/20" required data-id="element-1095" />
                    <button type="button" className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white" onClick={() => setShowCurrentPassword(!showCurrentPassword)} data-id="element-1096">
                      {showCurrentPassword ? <EyeOff className="w-5 h-5" data-id="element-1097" /> : <Eye className="w-5 h-5" data-id="element-1098" />}
                    </button>
                  </div>
                </div>
                <div className="space-y-2" data-id="element-1099">
                  <label className="block text-sm font-medium" data-id="element-1100">
                    Yeni Şifre
                  </label>
                  <div className="relative" data-id="element-1101">
                    <input type={showNewPassword ? 'text' : 'password'} value={newPassword} onChange={e => setNewPassword(e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-2.5 pr-10 focus:ring-2 ring-blue-500/20" required data-id="element-1102" />
                    <button type="button" className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white" onClick={() => setShowNewPassword(!showNewPassword)} data-id="element-1103">
                      {showNewPassword ? <EyeOff className="w-5 h-5" data-id="element-1104" /> : <Eye className="w-5 h-5" data-id="element-1105" />}
                    </button>
                  </div>
                </div>
                <div className="space-y-2" data-id="element-1106">
                  <label className="block text-sm font-medium" data-id="element-1107">
                    Yeni Şifre Tekrar
                  </label>
                  <div className="relative" data-id="element-1108">
                    <input type={showConfirmPassword ? 'text' : 'password'} value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-2.5 pr-10 focus:ring-2 ring-blue-500/20" required data-id="element-1109" />
                    <button type="button" className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white" onClick={() => setShowConfirmPassword(!showConfirmPassword)} data-id="element-1110">
                      {showConfirmPassword ? <EyeOff className="w-5 h-5" data-id="element-1111" /> : <Eye className="w-5 h-5" data-id="element-1112" />}
                    </button>
                  </div>
                </div>
                {passwordError && <p className="text-sm text-red-500" data-id="element-1113">{passwordError}</p>}
                <div className="pt-4 flex justify-end gap-3" data-id="element-1114">
                  <button type="button" onClick={() => setShowPasswordModal(false)} className="px-4 py-2 bg-white/5 hover:bg-white/10 rounded-lg transition-colors" data-id="element-1115">
                    İptal
                  </button>
                  <button type="submit" className="px-4 py-2 bg-gradient-to-r from-blue-600 to-blue-800 rounded-lg hover:opacity-90 transition-opacity" data-id="element-1116">
                    Güncelle
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>}
      {/* EMAIL UPDATE MODAL - LAÇİVERT TEMA */}
      {showEmailModal && <div className="fixed inset-0 bg-black/75 flex items-center justify-center p-4 z-50" data-id="element-1117">
          <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800 w-full max-w-md" data-id="element-1118">
            <div className="relative bg-black/90 rounded-xl p-6" data-id="element-1119">
              <div className="flex justify-between items-center mb-6" data-id="element-1120">
                <h2 className="text-xl font-bold" data-id="element-1121">E-posta Güncelle</h2>
                <button onClick={() => setShowEmailModal(false)} className="text-gray-400 hover:text-white" data-id="element-1122">
                  <X className="w-6 h-6" data-id="element-1123" />
                </button>
              </div>
              {!emailVerificationSent ? <form onSubmit={handleEmailSubmit} className="space-y-4" data-id="element-1124">
                  <div className="space-y-2" data-id="element-1125">
                    <label className="block text-sm font-medium" data-id="element-1126">
                      Yeni E-posta Adresi
                    </label>
                    <input type="email" value={newEmail} onChange={e => setNewEmail(e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-2.5 focus:ring-2 ring-blue-500/20" required data-id="element-1127" />
                  </div>
                  <div className="space-y-2" data-id="element-1128">
                    <label className="block text-sm font-medium" data-id="element-1129">
                      Mevcut Şifre
                    </label>
                    <div className="relative" data-id="element-1130">
                      <input type={showEmailPassword ? 'text' : 'password'} value={emailPassword} onChange={e => setEmailPassword(e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-2.5 pr-10 focus:ring-2 ring-blue-500/20" required data-id="element-1131" />
                      <button type="button" className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white" onClick={() => setShowEmailPassword(!showEmailPassword)} data-id="element-1132">
                        {showEmailPassword ? <EyeOff className="w-5 h-5" data-id="element-1133" /> : <Eye className="w-5 h-5" data-id="element-1134" />}
                      </button>
                    </div>
                  </div>
                  {emailError && <p className="text-sm text-red-500" data-id="element-1135">{emailError}</p>}
                  <div className="pt-4 flex justify-end gap-3" data-id="element-1136">
                    <button type="button" onClick={() => setShowEmailModal(false)} className="px-4 py-2 bg-white/5 hover:bg-white/10 rounded-lg transition-colors" data-id="element-1137">
                      İptal
                    </button>
                    <button type="submit" className="px-4 py-2 bg-gradient-to-r from-blue-600 to-blue-800 rounded-lg hover:opacity-90 transition-opacity" data-id="element-1138">
                      Güncelle
                    </button>
                  </div>
                </form> : <div className="text-center py-4 space-y-4" data-id="element-1139">
                  <div className="flex justify-center" data-id="element-1140">
                    <CheckCircle className="w-16 h-16 text-green-500" data-id="element-1141" />
                  </div>
                  <div data-id="element-1142">
                    <h3 className="text-lg font-medium mb-2" data-id="element-1143">
                      Doğrulama E-postası Gönderildi
                    </h3>
                    <p className="text-gray-400 text-sm" data-id="element-1144">
                      {newEmail} adresine doğrulama e-postası gönderdik. Lütfen
                      e-postanızdaki bağlantıya tıklayarak değişikliği
                      onaylayın.
                    </p>
                  </div>
                  <button onClick={() => setShowEmailModal(false)} className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors" data-id="element-1145">
                    Tamam
                  </button>
                </div>}
            </div>
          </div>
        </div>}
      {/* Logout Confirmation Modal */}
      {showLogoutModal && <div className="fixed inset-0 bg-black/75 flex items-center justify-center p-4 z-50" data-id="element-1146">
          <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800 w-full max-w-md" data-id="element-1147">
            <div className="relative bg-black/90 rounded-xl p-6" data-id="element-1148">
              <h3 className="text-lg font-bold mb-4" data-id="element-1149">Çıkış Yap</h3>
              <p className="text-gray-400 mb-6" data-id="element-1150">
                Çıkış yapmak istediğinizden emin misiniz?
              </p>
              <div className="flex gap-3" data-id="element-1151">
                <button onClick={() => setShowLogoutModal(false)} className="flex-1 px-4 py-2 bg-white/5 hover:bg-white/10 rounded-lg transition-colors" data-id="element-1152">
                  İptal
                </button>
                <button onClick={handleLogout} className="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 rounded-lg transition-colors" data-id="element-1153">
                  Çıkış Yap
                </button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}